import { Shape, styled, useTheme } from '@teko/ds-mobile';
import { SellerCard } from '@teko/teko-ecommerce';
import { useProductDetailState, useTenantConfig } from 'contexts';
import { t } from 'i18n';
import { useRouter } from 'next/router';

export const ProductProviderInfo = () => {
  const { product } = useProductDetailState();
  const { isMobile, hideProviderInfo } = useTenantConfig();
  const { colors } = useTheme();
  const provider = product?.provider || {
    name: '',
    logo: '',
    id: '',
  };
  const router = useRouter();

  if (hideProviderInfo) {
    return null;
  }

  return (
    <Shape backgroundColor="white">
      <StyledSellerCard
        padding={isMobile ? 's8' : 's16'}
        style={{
          borderColor: colors.border,
        }}
        name={provider.name}
        slogan={
          <ViewProduct
            onClick={() =>
              router.replace(
                `/cua-hang/${provider.id}?pageTitle=${provider.name}`,
              )
            }
          >
            {t('Xem sản phẩm')}
          </ViewProduct>
        }
        avatar={{ src: provider.logo || '' }}
        link={{
          href: `/cua-hang/${provider.id}?pageTitle=${provider.name}`,
        }}
        showSlogan={true}
      />
    </Shape>
  );
};

const ViewProduct = styled.div`
  border-radius: 4px;
  background-color: #f5f5f5;
  padding-left: 8px;
  padding-right: 8px;
  padding-top: 2px;
  padding-bottom: 2px;
  max-width: 105px;
  font-size: 13px;
  color: black;
  font-weight: 400;
  cursor: pointer;
`;

const StyledSellerCard = styled(SellerCard)`
  border-radius: 0;
  border-top: 1px dashed;
  border-bottom: 1px dashed;
  width: 100%;
`;
